import React, { Suspense, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VenueId } from '../../venues/venues.types';
import { VENUES } from '../../venues/venues.config';
import { setVenue } from '../../slices/venue/venue-slice';
import { AppLoader } from '../AppLoader';

export interface VenueShellProps {
    venueId?: VenueId;
}

export const VenueShell = (props: VenueShellProps) => {
    const params = useParams<{ venueId: VenueId }>();
    const resolvedVenueId = props.venueId ?? params.venueId;
    const dispatch = useDispatch() as any;

    useEffect(() => {
        if (resolvedVenueId && VENUES.some((v) => v.id === resolvedVenueId)) {
            dispatch(setVenue(resolvedVenueId));
        }
    }, [resolvedVenueId, dispatch]);

    const venue = VENUES.find((v) => v.id === resolvedVenueId);
    const themeClass = venue?.themeClass ?? '';

    return (
        <div className={themeClass}>
            <Suspense fallback={<AppLoader />}>
                <Outlet />
            </Suspense>
        </div>
    );
};
